import clsx from 'clsx'
import type {BioIconProps} from '../../icons/common-types'
import {FlagIconByLocale} from '../../icons/flag-icons-by-locale'

export default function BestPersonalCarePicksLogo({locale}: BioIconProps) {
  return (
    <div
      className={clsx(
        'domain_logo relative flex w-fit items-center gap-2 text-2xl font-semibold tablet:gap-1 tablet:text-base',
      )}
    >
      <svg
        className={clsx(
          'size-10 shrink-0 fill-[#EDEDED] tablet:size-8',
          locale?.toLowerCase() === 'uk' && '!fill-[#EF4444]',
        )}
        width="33"
        height="33"
        viewBox="0 0 33 33"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.6"
          d="M26.9813 11.6152C26.9813 11.8152 26.9813 12.0152 26.968 12.2019C24.928 11.4419 22.528 11.9086 20.928 13.3486C19.848 12.3752 18.448 11.8286 16.9546 11.8286C13.6746 11.8286 11.008 14.5086 11.008 17.8152C11.008 21.5886 12.9013 24.3486 14.7146 26.1352C14.568 26.1219 14.448 26.0952 14.3413 26.0552C10.888 24.8686 3.16797 19.9619 3.16797 11.6152C3.16797 7.93523 6.12796 4.96191 9.78129 4.96191C11.9546 4.96191 13.8746 6.0019 15.0746 7.61523C16.288 6.0019 18.208 4.96191 20.368 4.96191C24.0213 4.96191 26.9813 7.93523 26.9813 11.6152Z"
        />
        <path d="M24.4986 13.6152C23.0719 13.6152 21.7786 14.3086 20.9786 15.3752C20.1786 14.3086 18.8986 13.6152 17.4586 13.6152C15.0319 13.6152 13.0586 15.5886 13.0586 18.0419C13.0586 18.9886 13.2053 19.8552 13.4719 20.6552C14.7253 24.6152 18.5786 26.9752 20.4852 27.6286C20.7519 27.7219 21.1919 27.7219 21.4719 27.6286C23.3786 26.9752 27.2319 24.6152 28.4852 20.6552C28.7519 19.8419 28.8986 18.9752 28.8986 18.0419C28.8986 15.5886 26.9252 13.6152 24.4986 13.6152Z" />
      </svg>
      <span>Best Personal Care Picks</span>
      <FlagIconByLocale
        locale={locale}
        className="absolute -right-6 -top-2 size-7 shrink-0 -rotate-12 tablet:-right-4 tablet:-top-1 tablet:size-5"
      />
    </div>
  )
}
